import { format, formatDistanceToNow } from 'date-fns'

export const formatDate = (date) => {
  if (!date) return '—'
  try {
    return format(new Date(date), 'PPp')
  } catch {
    return '—'
  }
}

export const formatRelativeTime = (date) => {
  if (!date) return '—'
  try {
    return formatDistanceToNow(new Date(date), { addSuffix: true })
  } catch {
    return '—'
  }
}

/** LEAD → "Lead", CUSTOMER_ACCOUNT → "Customer account" */
export const entityLabel = (entityType) => {
  const words = entityType.toLowerCase().split('_')
  return words.join(' ').replace(/^./, (c) => c.toUpperCase())
}

/** LEAD → "Leads", OPPORTUNITY → "Opportunities" */
export const entityLabelPlural = (entityType) => {
  const label = entityLabel(entityType)
  if (/[^aeiou]y$/i.test(label)) return label.slice(0, -1) + 'ies'
  if (/(s|x|ch|sh)$/i.test(label)) return label + 'es'
  return label + 's'
}

/** "First name" → "firstName" (valid backend fieldKey) */
export const toFieldKey = (label) => {
  const words = label
    .normalize('NFKD')
    .replace(/[^a-zA-Z0-9 ]/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (words.length === 0) return ''
  const key = words
    .map((w, i) => (i === 0 ? w.toLowerCase() : w[0].toUpperCase() + w.slice(1).toLowerCase()))
    .join('')
  return /^[a-z]/.test(key) ? key.slice(0, 100) : `f${key}`.slice(0, 100)
}

/** "Sales pipeline" → "sales-pipeline" (valid backend form code) */
export const toFormCode = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 100)

/** Saves a Blob as a file via a temporary link. */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
